import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Input, Typography } from 'antd'

const Item = Form.Item
const { Text } = Typography

class CounselorChangeModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////       
    static propTypes = {
        setForm: PropTypes.func.isRequired,
        counselor: PropTypes.object.isRequired
    }

    fm = React.createRef();
    UNSAFE_componentWillMount() {
        this.props.setForm(this.fm)
    }

    handleChange(event) {
        //console.log(event.target.value)
    }

    /////////////////////////////////////////////////////////////     

    render() {
        const { YearGrade, GraduateYear, EducationalSystem, DepartmentName, ClassGradeCode, ClassGradeName, ClassTeacherName, ClassTeacherCode, CounselorCode, CounselorName } = this.props.counselor
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 8 }
        }
        //console.log(YearGrade, GraduateYear)
        return (
            <div>
                <Form ref={this.fm}>
                    <Item
                        {...formItemLayout}
                        label="輔導員代號"
                        name="CounselorCode"
                        initialValue={CounselorCode}
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入輔導員職號/學號' },
                        ]}
                    >
                        <Input placeholder="輔導員職號/學號" onBlur={this.handleChange}/>
                    </Item>
                    <Item
                        {...formItemLayout}
                        label="輔導員姓名"
                        name="CounselorName"
                        initialValue={CounselorName}
                    >
                        <Input placeholder="輔導員姓名" disabled />
                    </Item>
                    <Item
                        name="GraduateYear"
                        initialValue={GraduateYear}
                    >
                        <Input type="hidden"/>
                    </Item>
                    <Item
                        name="ClassGradeCode"
                        initialValue={ClassGradeCode}
                    >
                        <Input type="hidden"/>
                    </Item>
                </Form>
                <Text mark>對象班級：{YearGrade} / {EducationalSystem} / {DepartmentName} / {ClassGradeName} / 原班導：{ClassTeacherName} ({ClassTeacherCode})</Text>
            </div>
        )
    }
}


export default connect(
    state => ({ user: state.user }),
    {}
)(CounselorChangeModal)